<template>
  <div class="attachments-page">

    <div
      v-if="$can('create', permissionModule )"
      class="btn-actions-content"
    >
      <b-button
        class="btn-grad d-flex align-items-center"
        @click="openModal({action: 'create'})"
      >
        <VSIcons
          name="AddSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span class="align-middle">Adicionar</span>
      </b-button>
    </div>

    <b-input-group class="input-group-merge round search-input-filter">
      <b-input-group-prepend
        is-text
      >
        <VSIcons
          name="Search"
          color="#7D8E9E"
          width="18"
          height="18"
        />
      </b-input-group-prepend>
      <b-form-input
        id="filter-input"
        v-model="filter"
        placeholder="Buscar..."
        type="search"
      />
    </b-input-group>
    <b-table
      id="attachments-table"
      class="details-table mt-4"
      :items="items"
      :fields="fields"
      hover
      responsive
      details-td-class="align-middle"
      :busy="apiInCall"
      :per-page="perPage"
      :current-page="currentPage"
      small
      :filter="filter"
      :filter-included-fields="filterOn"
      empty-filtered-text="Não há resultados para sua pesquisa."
      empty-text="Não há registros para serem exibidos."
      show-empty
      @filtered="onFiltered"
    >
      <template #table-busy>
        <b-spinner variant="primary" />
      </template>
      <template
        v-if="$can('delete', permissionModule )"
        #head(select)
      >
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          @change="toggleAll('/system/inspect', 'Inspects')"
        />
      </template>
      <template
        v-if="$can('delete', permissionModule )"
        #cell(select)="row"
      >
        <b-form-checkbox
          v-model="selected"
          :value="row.item"
          @change="setItensToDelete({ itens: selected, api: 'system/inspect', fetchTable: 'Inspects' })"
        />
      </template>
      <template #cell(licensingAgency)="row">
        {{ row.item.licensingAgency ? row.item.licensingAgency.acronyms : 'Não informado' }}
      </template>
      <template #cell(issue_date)="row">
        <div class="d-flex align-items-center justify-content-center">
          {{ row.item.issue_date | formatLocalDate }}
          <VSIcons
            name="calendar"
            class="ml-2"
            height="18"
          />
        </div>
      </template>
      <template #cell(actions)="row">
        <b-dropdown
          no-caret
          right
          variant="light"
          menu-class="dropdown-table-actions"
          toggle-class="button-dropdown-actions"
        >
          <template #button-content>
            <VSIcons
              name="Actions"
              width="5"
              height="22"
            />
          </template>
          <b-dropdown-item
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'read'})"
          >
            <VSIcons
              name="Eye"
              width="21"
              height="21"
              color="#7D8E9E"
            />
            <span>
              Ver
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', permissionModule )" />
          <b-dropdown-item
            v-if="$can('update', permissionModule )"
            class="dropdown-table-item"
            @click="openModal({item: row.item, action: 'edit'})"
          >
            <VSIcons
              name="Edit"
              width="20"
              height="20"
              color="#7D8E9E"
            />
            <span>
              Editar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('update', permissionModule )" />
          <b-dropdown-item
            v-if="$can('update', permissionModule )"
            class="dropdown-table-item"
            @click="uploadFile(row.item)"
          >
            <VSIcons
              name="PaperClip"
              width="22"
              height="22"
              color="#7D8E9E"
            />
            <span>
              Anexar
            </span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="$can('delete', permissionModule )" />
          <b-dropdown-item
            v-if="$can('delete', permissionModule )"
            class="dropdown-table-item"
            @click="deleteItem(row.item)"
          >
            <VSIcons
              name="TrashSquare"
              width="21"
              height="21"
              color="#7D8E9E"
            />
            <span>
              Excluir
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="attachments-table"
    >
      <template #prev-text>
        <VSIcons name="ArrowLeft" />
      </template>
      <template #next-text>
        <VSIcons name="ArrowRight" />
      </template>
    </b-pagination>
    <VSModal
      name="UploadFile"
      :properties="properties"
    />
    <VSModal
      width="970"
      name="AddSurveys"
      :properties="properties"
    />
    <VSModal
      width="570"
      :properties="itemToDelete"
      name="DeleteOneItem"
    />
  </div>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BSpinner,
  BPagination,
} from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'
import { formatLocalDate } from '@core/utils/filter'
import { tableConfig } from '@core/mixins/ui/forms'
import VSIcons from '@/assets/icons/VSIcons.vue'
import VSModal from '@/components/modals/VSModal.vue'

export default {
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTable,
    BButton,
    VSIcons,
    BFormCheckbox,
    BSpinner,
    BPagination,
    VSModal,
  },
  filters: {
    formatLocalDate,
  },
  mixins: [
    tableConfig,
  ],
  props: {
    items: {
      type: Array,
      required: true,
    },
    module: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      apiPath: '/system/inspects',
      properties: {},
      itemToDelete: { api: '/system/inspect', fetchTable: 'Inspects' },
      fields: [
        {
          label: '',
          key: 'select',
          tdClass: 'align-middle',
        },
        {
          label: 'Número',
          key: 'number',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Título',
          key: 'title',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Objeto',
          key: 'object',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Órgão',
          key: 'licensingAgency',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Departamento',
          key: 'department',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Data de Emissão',
          key: 'issue_date',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: 'Técnico',
          key: 'technician',
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          label: '',
          key: 'actions',
          tdClass: 'align-middle',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({ apiInCall: 'app/getApiInCall' }),
    permissionModule() {
      if (this.module) { return 'licensesconditions' }
      return 'licensingagency'
    },
  },
  methods: {
    ...mapMutations({
      setItensToDelete: 'app/SET_ITENS_DELETE',
    }),
    openModal(item) {
      this.properties = item
      this.properties.module = this.module
      this.showModal('AddSurveys')
    },
    uploadFile(row) {
      this.properties.action = 'create'
      this.properties.relations = [{ name: 'opinionsInspec_id', id: row.id }]
      if (this.module) {
        this.properties.relations.push({ name: 'licensingCondition_id', id: this.$route.params.id })
      } else {
        this.properties.relations.push({ name: 'licensing_id', id: this.$route.params.id })
      }
      this.showModal('UploadFile')
    },
  },
}
</script>
<style lang="scss">

</style>
